<div fxShow="true" fxHide.lt-md="true">
    <mat-toolbar class="mat-toolbar" color="primary">
        <mat-toolbar-row>


            <!--img alt="GARRAX" class="menu-bar_scratch-logo_2uReV menu-bar_clickable_1g3uo" draggable="false" src="https://brickly.mx/garrax/static/assets/a1b12e9163daea772ee8b2330f44bfe2.svg" style="height: 45px;" (click)="goHome()"-->
            <img alt="Brickly" class="menu-bar_scratch-logo_2uReV menu-bar_clickable_1g3uo" draggable="false" src="assets/images/brickly-logo.svg" style="height: 45px;" (click)="goHome()">
            <!-- button mat-stroked-button color="accent" (click)="goHome()">GARRAX</button -->

            <button class="my-button" mat-button [matMenuTriggerFor]="languageMenu" matTooltip="{{'toolbar.select_language' | translate}}"><mat-icon>language</mat-icon></button>
            <mat-menu #languageMenu="matMenu" yPosition="above">
                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('es')">
                  español
                </button>

                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('en')">
                  english
                </button>

                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('gl')">
                  galego
                </button>
                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('ca')">
                  catalá
                </button>
                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('eu')">
                  euskera
                </button>
                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('it')">
                  italiano
                </button>
                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('de')">
                  deutsch
                </button>
                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('el')">
                  Ελληνικά
                </button>
                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('pt')">
                  português
                </button> 
            </mat-menu>

            <app-ml-filemenu></app-ml-filemenu>

            <input style="width: 150px" matInput #inputNameModel (blur)="updateModelName($event)" class="model-name" [(ngModel)]="labeledDataManager.name" />

            <button class="my-button" class="my-menu-button" mat-button [matMenuTriggerFor]="learnMenu">{{'toolbar.learn' | translate}}<mat-icon>expand_more</mat-icon></button>
            <mat-menu #learnMenu="matMenu" yPosition="above">
                <button mat-menu-item style="margin-right: 10px;" matTooltip="{{'toolbar.tutorials' | translate}}" (click)="tutorials()">
                  {{'toolbar.tutorials' | translate}}
                </button>

                <button mat-menu-item (click)="manual()">
                  {{'toolbar.manual' | translate}}
                </button>

                <button mat-menu-item (click)="about()">
                  {{'toolbar.about' | translate}}
                </button>
            </mat-menu>

	    <!--
            <button class="my-button" matTooltip="{{'toolbar.open.hint' | translate}}" mat-button (click)="openMyStuff()">
              <mat-icon>folder</mat-icon>
            </button>
            <button class="my-button" matTooltip="{{'toolbar.openshared.hint' | translate}}" mat-button (click)="openSharedStuff()">
              <mat-icon>folder_shared</mat-icon>
            </button>
	    -->

            <mat-slide-toggle  [(ngModel)]="labeledDataManager.advanced">
              <span style="font-size: small;" *ngIf="!labeledDataManager.advanced">{{'toolbar.mode-off' | translate}}</span>
              <span style="font-size: small;" *ngIf="labeledDataManager.advanced">{{'toolbar.mode-on' | translate}}</span>
            </mat-slide-toggle>

            <span class="space"></span>
            <span class="fill-remaining-space"></span>
            
            <button (click)="about()" class="my-button" class="my-menu-button" mat-button>{{'toolbar.about' | translate}}</button>

            <!--app-ml-login></app-ml-login -->
        </mat-toolbar-row>
    </mat-toolbar>
</div>

<div fxShow="true" fxHide.gt-sm="true">
    <mat-toolbar class="mat-toolbar" color="primary">
        <mat-toolbar-row>
            <button class="my-button" mat-button [matMenuTriggerFor]="languageMenu"><mat-icon>language</mat-icon></button>
            <button mat-stroked-button color="accent" (click)="goHome()">GARRAX</button>

            <button class="my-button" mat-button [matMenuTriggerFor]="languageMenu"><mat-icon>language</mat-icon></button>
            <mat-menu #languageMenu="matMenu" yPosition="above">
                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('es')">
                español
              </button>

                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('en')">
                english
              </button>

                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('gl')">
                galego
                </button>

                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('ca')">
                  català
                </button>

                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('it')">
                  italiano
                </button>

                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('de')">
                  deutsch
                </button>

                <button mat-menu-item style="margin-right: 10px;" (click)="selectLanguage('el')">
                  Ελληνικά 
                </button>
            </mat-menu>

            <app-ml-filemenu></app-ml-filemenu>
            <input style="width: 100px" matInput #inputNameModel (blur)="updateModelName($event)" class="model-name" [(ngModel)]="labeledDataManager.name" />


        </mat-toolbar-row>

        <mat-toolbar-row>
            <button class="my-button" class="my-menu-button" mat-button [matMenuTriggerFor]="learnMenu">{{'toolbar.learn' | translate}}<mat-icon>expand_more</mat-icon></button>
            <mat-menu #learnMenu="matMenu" yPosition="above">
                <button mat-menu-item style="margin-right: 10px;" matTooltip="{{'toolbar.tutorials' | translate}}" (click)="tutorials()">
                {{'toolbar.tutorials' | translate}}
              </button>

                <button mat-menu-item (click)="manual()">
                {{'toolbar.manual' | translate}}
              </button>

                <button mat-menu-item (click)="about()">
                {{'toolbar.about' | translate}}
              </button>
            </mat-menu>

            <span class="space"></span>
            <span class="fill-remaining-space"></span>
            <button (click)="about()" class="my-button" class="my-menu-button" mat-button>{{'toolbar.about' | translate}}</button>
            <!--app-ml-login></app-ml-login -->
        </mat-toolbar-row>
    </mat-toolbar>

</div>
